import React from 'react';

const Error404Icon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="134" height="69" viewBox="0 0 134 69">
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            fill="#1EA0C0"
            d="M37.6 67.5L37.6 57.6 42.9 57.6 42.9 48.6 37.6 48.6 37.6 29.3 28 29.3 28 48.6 10.5 48.6 33.1 0.6 22.4 0.6 0 48.6 0 57.6 28 57.6 28 67.5z"
            transform="translate(-653 -135) translate(653 135)"
          />
          <path
            fill="#68AE45"
            d="M66.7 68.1c4.867 0 9.25-1.667 13.15-5 3.9-3.333 5.85-8.067 5.85-14.2V19.3c0-6.133-1.95-10.883-5.85-14.25C75.95 1.683 71.567 0 66.7 0c-5 0-9.417 1.683-13.25 5.05S47.7 13.167 47.7 19.3v29.6c0 6.133 1.917 10.867 5.75 14.2 3.833 3.333 8.25 5 13.25 5zm0-9.5c-2.933 0-5.233-.9-6.9-2.7-1.667-1.8-2.5-4.333-2.5-7.6V19.9c0-3.267.833-5.8 2.5-7.6 1.667-1.8 3.967-2.7 6.9-2.7 2.8 0 5.067.9 6.8 2.7 1.733 1.8 2.6 4.333 2.6 7.6v28.4c0 3.267-.867 5.8-2.6 7.6-1.733 1.8-4 2.7-6.8 2.7z"
            transform="translate(-653 -135) translate(653 135)"
          />
          <path
            fill="#1EA0C0"
            d="M128 67.5L128 57.6 133.3 57.6 133.3 48.6 128 48.6 128 29.3 118.4 29.3 118.4 48.6 100.9 48.6 123.5 0.6 112.8 0.6 90.4 48.6 90.4 57.6 118.4 57.6 118.4 67.5z"
            transform="translate(-653 -135) translate(653 135)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Error404Icon;
